import { useState, useEffect } from "react";
import {
  fetchTagsCategoriesAsync,
  fetchExperimentDataForTournamentAsync,
  type TagsData,
} from "@/api/tournaments";

interface FilterData {
  lessonsTagsData: TagsData;
  experimentLanguagesList: Array<{ name: string }>;
  experimentDifficultiesList: Array<{ name: string }>;
}

export function useTournamentFilterData(currentTenantName: string | undefined): {
  filterData: FilterData;
  isLoading: boolean;
} {
  const [filterData, setFilterData] = useState<FilterData>({
    lessonsTagsData: {},
    experimentLanguagesList: [],
    experimentDifficultiesList: [],
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!currentTenantName) return;

    let cancelled = false;

    const loadFilterData = async () => {
      setIsLoading(true);
      try {
        const [tagsData, experimentData] = await Promise.all([
          fetchTagsCategoriesAsync(),
          fetchExperimentDataForTournamentAsync(),
        ]);
        if (cancelled) return;
        setFilterData({
          lessonsTagsData: tagsData,
          experimentLanguagesList: experimentData.languages ?? [],
          experimentDifficultiesList: experimentData.difficulties ?? [],
        });
      } catch (error) {
        console.error("Error fetching filter data:", error);
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };

    loadFilterData();
    return () => {
      cancelled = true;
    };
  }, [currentTenantName]);

  return { filterData, isLoading };
}
